import { DeletePostActions } from './actions/delete-post/delete-post.component';



/*
  Generated class for the FirebaseProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export {
	DeletePostActions,
	
}